import React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import "../../../../../App.css";
import "../../projectdetail.css";
import { ISimulatorRow } from "../../../../../webapi/service/getSimulator";

export interface IProps extends WithTranslation {
  /**
   * タイトル
   */
  title: string;
  /**
   * ダイアログを表示する場合はtrue
   */
  show: boolean;
  /**
   * シミュレータ情報一覧
   */
  simulators: ISimulatorRow[];
  /**
   * OKボタンが押された場合に呼び出されます
   */
  onOk: (step: boolean, impulse: boolean, files?: string[]) => void;
  /**
   * キャンセルボタンが押された場合に呼び出されます
   */
  onCancel: () => void;
}

interface IState {
  /**
   * stepでのシミュレーションの有無
   */
  step: boolean;
  /**
   * impulseでのシミュレーションの有無
   */
  impulse: boolean;
}

class SimulatorSettingNofile extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { step: false, impulse: false };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClickCancel = this.handleClickCancel.bind(this);
    this.handleChangeStep = this.handleChangeStep.bind(this);
    this.handleChangeImpulse = this.handleChangeImpulse.bind(this);
  }

  handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    this.props.onOk(this.state.step, this.state.impulse);
  }

  handleClickCancel() {
    this.setState({ step: false, impulse: false });
    this.props.onCancel();
  }

  handleChangeStep(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ step: e.target.checked });
  }

  handleChangeImpulse(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ impulse: e.target.checked });
  }

  render() {
    const { t } = this.props;
    const sisetting = (
      <Form>
        <Form.Check
          label={t("simulator_simulation_si_step")}
          id="step"
          checked={this.state.step}
          onChange={this.handleChangeStep}
        />
        <Form.Check
          label={t("simulator_simulation_si_impulse")}
          id="impulse"
          checked={this.state.impulse}
          onChange={this.handleChangeImpulse}
        />
      </Form>
    );
    const okBtn =
      this.state.step || this.state.impulse ? (
        <Button className="dialog-button" variant="primary" type="submit">
          {t("prompt_ok")}
        </Button>
      ) : (
        <Button
          className="dialog-button"
          variant="primary"
          type="submit"
          disabled
        >
          {t("prompt_ok")}
        </Button>
      );
    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClickCancel}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="dialog-caption">{t("simulator_simulation_si")}</div>
            <div className="dialog-checkitem">{sisetting}</div>
          </div>
          <Form onSubmit={this.handleSubmit}>
            <div className="dialog-buttons">
              {okBtn}
              <Button
                className="dialog-button"
                variant="secondary"
                onClick={this.handleClickCancel}
              >
                {t("prompt_cancel")}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

/**
 * シミュレータシミュレーション時の設定ダイアログ
 * （データファイルがプロジェクトに一つも無い場合）
 */
export default withTranslation()(SimulatorSettingNofile);
